import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AuthService} from '@services/auth.service';
import {UserService} from '@services/user.service';
import {RouterLink, RouterLinkActive} from '@angular/router';
import {environment} from '@env/environment';

@Component({
  selector: 'app-sidemenu',
  imports: [CommonModule, RouterLink, RouterLinkActive],
  standalone: true,
  templateUrl: './sidemenu.component.html',
  styleUrl: './sidemenu.component.css'
})
export class SidemenuComponent {
  @Input() menuOpen: boolean = false;
  @Output() closeMenu = new EventEmitter<void>(); // Rinominato per chiarezza

  constructor(
    public authService: AuthService,
    public userService: UserService
  ) {}

  // Questa funzione ora serve solo a chiudere la tendina
  // perché il cambio pagina è gestito dal routerLink
  onNavigate(action: string) {
    setTimeout(() => {
    if (action === 'close') {
      this.closeMenu.emit();
    }
    }, 100 )
  }

  logoutRedirect(): void {
    //const currentOrigin = environment.api.BE || window.location.origin;
    this.authService.logout();
    //window.location.href = `${currentOrigin}/web/session/logout?redirect=${encodeURIComponent(window.location.origin)}`;
  }

}
